import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const PricingTextBlock = (): JSX.Element => (
  <Stack
    maxWidth='width-xl'
    margin={['spacing-none', 'spacing-auto']}
  >
    <HeadingAndSupportingText
      gap='spacing-3xl'
      subHeadingGap='spacing-lg'
      subHeading={{
        text: 'Pricing',
        type: 'paragraph',
        size: 'lg',
        textAlign: 'center',
        color: 'text-brand-secondary',
        fontWeight: 'font-weight-semibold',
      }}
      heading={{
        text: 'Plans that give you a plan',
        type: 'heading',
        size: 'xl',
        letterSpacing: -1.4,
        textAlign: 'center',
      }}
      supportingText={{
        text: 'You don’t have to figure it out alone. Pick a path and we’ll help you walk it. Bonus? No add-ons that add up as you grow.',
        type: 'paragraph',
        size: 'xl',
        color: 'text-tertiary',
        textAlign: 'center',
      }}
    />
  </Stack>
);

export default PricingTextBlock;
